/* ============
 * Edi Order Item Transformer
 * ============
 *
 * The transformer for the Edi order item.
 */

import Transformer from './transformer';

export default class EdiOrderItemTransformer extends Transformer {

  static fetch(ediOrderItem) {
    return {
      id: ediOrderItem.id,
      ediOrderId: ediOrderItem.edi_order_id,
      productId: ediOrderItem.product_id,
      ediOrderItemProductId: ediOrderItem.edi_order_item_product_id,
      lineNumber: ediOrderItem.line_number,
      description: ediOrderItem.description,
      quantityOrdered: ediOrderItem.quantity_ordered,
      quantityConfirmed: ediOrderItem.quantity_confirmed,
      quantityReceived: ediOrderItem.quantity_received,
      packageUnitType: ediOrderItem.package_unit_type,
      price: ediOrderItem.price,
      buyerOrderQuantity: ediOrderItem.buyer_order_quantity,
      buyerOrderLineNumber: ediOrderItem.buyer_order_line_number,
      supplierOrderQuantity: ediOrderItem.supplier_order_quantity,
      supplierOrderLineNumber: ediOrderItem.supplier_order_line_number,
      orderResponseStatus: ediOrderItem.order_response_status,
      productNumber: ediOrderItem.product_number,
      batchIds: ediOrderItem.batch_ids,
    };
  }

  static send(ediOrderItem) {
    return {
      id: ediOrderItem.id,
      edi_order_id: ediOrderItem.ediOrderId,
      product_id: ediOrderItem.productId,
      edi_order_item_product_id: ediOrderItem.ediOrderItemProductId,
      line_number: ediOrderItem.lineNumber,
      description: ediOrderItem.description,
      quantity_ordered: ediOrderItem.quantityOrdered,
      quantity_confirmed: ediOrderItem.quantityConfirmed,
      quantity_received: ediOrderItem.quantityReceived,
      package_unit_type: ediOrderItem.packageUnitType,
      price: ediOrderItem.price,
      buyer_order_quantity: ediOrderItem.buyerOrderQuantity,
      buyer_order_line_number: ediOrderItem.buyerOrderLineNumber,
      supplier_order_quantity: ediOrderItem.supplierOrderQuantity,
      supplier_order_line_number: ediOrderItem.supplierOrderLineNumber,
      order_response_status: ediOrderItem.orderResponseStatus,
      product_number: ediOrderItem.productNumber,
      batch_ids: ediOrderItem.batchIds,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/ediOrderItem.js